<div>
  <a [ngClass]="clicked ? 'active' : ''" id="hamburger-icon" title="Menu">
    <span class="line line-1"></span>
    <span class="line line-2"></span>
    <span class="line line-3"></span>
  </a>
</div>
